<div class="grid">
  <div class="grid__box grid__box--size-2">
    <app-field>
      <label>Имя события</label>
      <input type="text" class="input-text" [(ngModel)]="action" />
    </app-field>
  </div>
</div>
<div class="grid mt-8">
  <div class="grid__box grid__box--size-6">
    <app-field>
      <label>Данные</label>
      <textarea type="textarea" class="input-textarea" rows="30" [(ngModel)]="data"></textarea>
    </app-field>
  </div>
</div>
<div class="mt-16">
  <button class="button" (click)="sendMessage()">Отправить сообщение</button>
</div>

<div class="mt-32">
  <div *ngIf="output">{{ output }}</div>
</div>
